<template>
    <!-- 订单详情 -->
    <el-card class="container" v-loading="orderInfoLoading" shadow="never">
        <div slot="header">
            <el-button type="text" class="backBtn" @click="close">返回</el-button>
            <span class="font18"> {{ orderInfo.equipmentName }} </span>
        </div>
        <div style="overflow: auto; height: calc(100vh - 300px); padding: 10px;">
            <el-card class="info-card">
                <div class="tips" v-if="orderStatus == '待支付'">订单即将关闭，请及时支付</div>
		        <div class="tips" v-if="orderStatus == '待审核'">您的团队已开启订单审核设置，请联系团长或管理员审核订单</div>
		        <div class="tips" v-if="orderStatus == '待寄样'">请尽快上传物流信息</div> 
		        <div class="tips" v-if="orderStatus == '待取样'">取样员将在 1-3 个工作日内与您联系取样</div>
		        <div class="tips" v-if="orderStatus == '待实验'">预约时间：{{ appointmentStartDate }}</div>
		        <div class="tips" v-if="orderStatus == '待核对'">实验已完成，请确认实验金额并完成支付流程</div>
		        <div class="tips" v-if="orderStatus == '已完成'">检测已全部完成，可 <span class="download-result" @click="downloadResult(orderInfo)">下载实验结果</span> 查看</div>
		        <div class="tips" v-if="orderStatus == '待回运'">实验已完成，请确认实验金额并完成支付流程</div>
		        <div class="tips" v-if="orderStatus == '售后中'">已提交客服，请耐心等候客服联系</div>
                <div class="baseInfo-box">
                    <img class="equipment-pic" :src="orderInfo.equipmentPic" alt="">
                    <div class="baseInfo">
                        <div class="info-box">
                            <div class="info-box-title">订单状态</div>
                            <div class="info-box-content">
                                <span> {{ orderStatus }} </span>
                                <span style="margin-left: 15px; color: #FF4A2B;" v-if="orderStatus == '待支付' || orderStatus == '待审核' || orderStatus == '待核对'"> {{ timeout }} </span>
                            </div>
                        </div>
                        <div class="info-box">
                            <div class="info-box-title">订单编号</div>
                            <div class="info-box-content"> {{ orderInfo.orderCode || '--' }} </div>
                        </div>
                        <div class="info-box">
                            <div class="info-box-title">送样方式</div>
                            <div class="info-box-content"> {{ postMethod }} </div>
                        </div>
                        <div class="info-box">
                            <div class="info-box-title">总样品数</div>
                            <div class="info-box-content"> {{ orderInfo.sampleNumber || '--' }} </div>
                        </div>
                        <div class="info-box">
                            <div class="info-box-title">支付方式</div>
                            <div class="info-box-content"> {{ dictFilter(orderInfo.prepaidPayment ? orderInfo.prepaidPayment.toString() : '--', 'prepaidPayment') }} </div>
                        </div>
                        <div class="info-box">
                            <div class="info-box-title">下单时间</div>
                            <div class="info-box-content"> {{ orderInfo.addDate || '--' }} </div>
                        </div>
                        <div class="info-box">
		    		    	<div class="info-box-title">支付时间</div>
		    		    	<div class="info-box-content"> {{ orderInfo.orderDate || '--' }} </div>
		    		    </div>
		    		    <div class="info-box">
		    		    	<div class="info-box-title">预约检测时间</div>
		    		    	<div class="info-box-content"> {{ appointmentStartDate }} </div>
		    		    </div>
		    		    <div class="info-box">
		    		    	<div class="info-box-title">完成时间</div>
		    		    	<div class="info-box-content"> {{ orderInfo.experimentEndDate || '--' }} </div>
		    		    </div>
		    		    <div class="info-box">
		    		    	<div class="info-box-title">结算时间</div>
		    		    	<div class="info-box-content"> {{ orderInfo.finishOrderDate || '--' }} </div>
		    		    </div>
		    		    <div class="info-box" v-if="orderInfo.recycleStatus != 1">
		    		    	<div class="info-box-title">样品回运单号</div>
		    		    	<div class="info-box-content"> {{ orderInfo.transportNumber || '--' }} </div>
		    		    </div>
                        <div class="info-box">
                            <div class="info-box-title"> {{ orderInfo.postMethod == 2 ? '取样地址：' : '收样地址：' }} </div>
                            <div class="info-box-content"> {{ addressInfo }} </div>
                        </div>
                    </div>
                </div>
            </el-card>
            <el-card class="info-card">
                <div slot="header">
                    <span>预约信息</span>
                </div>
                <div class="price">
                    <div class="info-box">
		    			<div class="info-box-title">预约单原价</div>
		    			<div class="info-box-content"> ￥{{ orderInfo.originalPrice }} </div>
		    		</div>
                    <div class="info-box">
		    			<div class="info-box-title" v-if="orderInfo.prepaidPayment"> {{ dictFilter(orderInfo.prepaidPayment.toString(), 'prepaidPayment') }} 结算</div>
		    			<div class="info-box-title" v-else>应付</div>
		    			<div class="info-box-content"> ￥{{ orderInfo.totalCost }} </div>
		    		</div>
                </div>
                <div class="original-box">
		    		<div class="info-box" v-if="orderInfo.expeditedProduction">
		    			<div class="info-box-title">加急制作</div>
		    			<div class="info-box-content"> ￥{{ orderInfo.expeditedProduction }} </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.postMethod == 1 && orderInfo.postPayment == 1">
		    			<div class="info-box-title">到付运费</div>
		    			<!-- <div class="info-box-content"> ￥{{ orderInfo.freightCollected }} </div> -->
		    			<div class="info-box-content"> ￥12 </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.ifRecycle == 1 && orderInfo.whiteFlag != 1">
		    			<div class="info-box-title">样品回收</div>
		    			<!-- <div class="info-box-content"> ￥{{ orderInfo.sampleRecovery }} </div> -->
		    			<div class="info-box-content">
                            <span v-if="orderInfo.addressId == 298">¥12</span>
                            <span v-else>¥50</span>
                        </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.cashCoupon">
		    			<div class="info-box-title">赠送金</div>
		    			<div class="info-box-content">-￥{{ orderInfo.cashCoupon }} </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.couponMoney">
		    			<div class="info-box-title">优惠券</div>
		    			<div class="info-box-content"> -￥{{ orderInfo.couponMoney }} </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.discountMoney">
		    			<div class="info-box-title">使用折扣</div>
		    			<div class="info-box-content">
		    				<div v-if="orderInfo.discountType == 1">个人折扣</div>
		    				<div v-if="orderInfo.discountType == 2">团队折扣</div>
		    				<div style="margin-left: 20px">-￥{{ orderInfo.discountMoney }} </div>
		    			</div>
		    		</div>
                </div>
            </el-card>
            <el-card class="info-card" v-if="orderStatus == '已完成' || orderStatus == '申请开票' || orderStatus == '待核对'">
                <div slot="header">
                    <span>检测信息</span>
                </div>
                <div class="price">
                    <div class="info-box">
		    			<div class="info-box-title">预约单原价</div>
		    			<div class="info-box-content"> ￥{{ orderInfo.originalPrice }} </div>
		    		</div>
                    <div class="info-box">
		    			<div class="info-box-title"> {{ dictFilter(orderInfo.prepaidPayment ? orderInfo.prepaidPayment.toString() : '--', 'prepaidPayment') }} 结算</div>
		    			<div class="info-box-content"> ￥{{ orderInfo.experimentTotalCost }} </div>
		    		</div>
                </div>
                <el-table :header-cell-style="{background:'#F5F5F5'}" border :data="orderInfo.checkItemList">
                    <el-table-column prop="detectionItemName" label="检测项目"></el-table-column>
                    <el-table-column label="单价">
                        <template slot-scope="scope">
                            <span> ￥{{ scope.row.unitPrice }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quantity" label="数量"></el-table-column>
                    <el-table-column prop="detectionMeteringUnit" label="单位"></el-table-column>
                    <el-table-column label="小计">
                        <template slot-scope="scope">
                            <span> ￥{{ scope.row.subtotal }} </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="experiment-box">
		    		<div class="info-box" v-if="orderInfo.expeditedProduction">
		    			<div class="info-box-title">加急制作</div>
		    			<div class="info-box-content"> ￥{{ orderInfo.expeditedProduction }} </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.postMethod == 1 && orderInfo.postPayment == 1">
		    			<div class="info-box-title">到付运费</div>
		    			<!-- <div class="info-box-content"> ￥{{ orderInfo.freightCollected }} </div> -->
		    			<div class="info-box-content"> ￥12 </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.ifRecycle == 1 && orderInfo.whiteFlag != 1">
		    			<div class="info-box-title">样品回收</div>
		    			<!-- <div class="info-box-content"> ￥{{ orderInfo.sampleRecovery }} </div> -->
		    			<div class="info-box-content">
                            <span v-if="orderInfo.addressId == 298">¥12</span>
                            <span v-else>¥50</span>
                        </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.experimentCashCoupon">
		    			<div class="info-box-title">赠送金</div>
		    			<div class="info-box-content">-￥{{ orderInfo.experimentCashCoupon }} </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.experimentCoupon">
		    			<div class="info-box-title">优惠券</div>
		    			<div class="info-box-content"> -￥{{ orderInfo.experimentCoupon }} </div>
		    		</div>
		    		<div class="info-box" v-if="orderInfo.experimentDiscountMoney">
		    			<div class="info-box-title">使用折扣</div>
		    			<div class="info-box-content">
		    				<div v-if="orderInfo.discountType == 1">个人折扣</div>
		    				<div v-if="orderInfo.discountType == 2">团队折扣</div>
		    				<div style="margin-left: 20px">-￥{{ orderInfo.experimentDiscountMoney }} </div>
		    			</div>
		    		</div>
                    <div class="info-box" v-if="orderInfo.experimentalRemark">
		    			<div class="info-box-title">结束实验备注</div>
		    			<div class="info-box-content"> {{ orderInfo.experimentalRemark }} </div>
		    		</div>
                </div>
            </el-card>
            <el-card class="info-card">
                <div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
                    <span>预约单详情</span>
                    <el-button type="success" :loading="exportExperimentLoading" @click="exportExperiment">导出PDF</el-button>
                </div>
                <div class="detection-box">
                    <div class="detection-title"> {{ orderInfo.equipmentName }} （ {{ orderInfo.orderCode }} ）</div>
                    <div style="display: flex;">
                        <div class="detection-info">
                            <div class="detection-info-title">预约检测时长</div>
                            <div class="detection-info-content"> {{ orderInfo.detectionDuration }} h</div>
                        </div>
                        <div class="detection-info">
                            <div class="detection-info-title">预约检测时间段</div>
                            <div class="detection-info-content"> {{ orderInfo.appointmentStartDate }} ~ {{ orderInfo.appointmentEndDate }} </div>
                        </div>
                    </div>
                    <div class="fieId-title">全局问题</div>
                    <div class="detection-info" v-for="item in globalInfo" :key="item.label">
                        <div class="detection-info-title">{{ item.label }}</div>
                        <div class="detection-info-content"> {{ item.value || '--' }} </div>
                    </div>
                    <div v-for="(item, index) in groupsInfo" :key="index">
		            	<div class="fieId-title"> {{ item.groupName }} </div>
		            	<div class="detection-info" v-for="(item_, index_) in item.groupData" :key="index_">
		            		<div class="detection-info-title"> {{ item_.label }} </div>
		            		<div class="detection-info-content"> {{ item_.value || '--' }} </div>
		            	</div>
		            </div>
                    <div class="fieId-title">附件</div>
                    <div class="file-list">
                        <div v-if="fileList.length">
                            <div class="file" v-for="(item, index) in fileList" :key="index" @click="downloadFile(item)"> {{ item.label }} </div>
                        </div>
                        <div v-else> {{ '--' }}</div>
                    </div>
                    <div class="fieId-title">实验留言</div>
		            <div class="message"> {{ orderInfo.equipmentSubscribe.message || '--' }} </div>
                    <div class="fieId-title">订单备注</div>
		            <div class="message"> {{ orderInfo.customRemark || '--' }} </div>
                </div>
            </el-card>
        </div>
    </el-card>
</template>

<script>
import dayjs from "dayjs"
import duration from 'dayjs/plugin/duration'
import { timeFormat } from "@/utils/timeFormat.js"
import { orderInfo } from "@/api/request.js"
dayjs.extend(duration)

export default {
    data() {
        return {
            imgurl: process.env.VUE_APP_FILE_API,
            orderInfoLoading: false,
            exportExperimentLoading: false,
            orderInfo: {
                equipmentSubscribe: {}
            }, //订单详情
            orderStatus: '',// 订单状态
            timeout: '',//倒计时---秒数
            countTimer: null,//倒计时--计时器
            globalInfo: [],//全局字段数据
			groupsInfo: [],//样品组字段数据
            fileList: [],//附件列表
        }
    },
    computed: {
        appointmentStartDate() {
            let str = ''
            if(this.orderInfo.equipmentSubscribe) {
                str = this.orderInfo.equipmentSubscribe.appointmentStartDate || '--'
            } else {
                str = '--'
            }
            return str
        },
        postMethod() {
			let string_1 = ''
			let string_2 = ''
			switch(this.orderInfo.postMethod) {
				case 1:
				    string_1 = '自行邮寄'
					if(this.orderInfo.postPayment == 1) {
						string_2 = '/运费到付'
					} else if(this.orderInfo.postPayment == 2) {
						string_2 = '/运费自付'
					}
					break
				case 2:
				    string_1 = '上门取样'
					break
				case 3:
				    string_1 = '自己送样'
					break
			}
			return string_1 + string_2
		},
        addressInfo() {
            let string = ''
			switch(this.orderInfo.postMethod) {
				case 1:
				    string = `${this.orderInfo.deliveryLeader}: ${this.orderInfo.deliveryPhone} ${this.orderInfo.deliveryAddress}`
					break
				case 2:
				    string = `${this.orderInfo.samplingContact}: ${this.orderInfo.samplingContactPhone} ${this.orderInfo.homeSamplingAddress + this.orderInfo.detailedAddress}`
					break
				case 3:
				    string = `${this.orderInfo.deliveryLeader}: ${this.orderInfo.deliveryPhone} ${this.orderInfo.deliveryAddress}`
					break
			}
			return string
        },
    },
    methods: {
        // 获取订单详情
        getOrderInfo(orderId) {
            this.$nextTick(async () => {
                this.orderInfoLoading = true
                const res = await orderInfo(orderId)
                res.data.equipmentPic = this.imgurl + res.data.equipmentFileList[0].url
                res.data.detectionDuration = res.data.equipmentSubscribe.duration
                res.data.appointmentStartDate = res.data.equipmentSubscribe.appointmentStartDate
                res.data.appointmentEndDate = res.data.equipmentSubscribe.appointmentEndDate
                this.orderInfo = res.data
                this.orderStatus = this.dictFilter(this.orderInfo.status ? this.orderInfo.status.toString() : '-', 'isOrderStatus')
                let startTime = undefined
			    let timeEnd = undefined
			    let now = undefined
                let timeDifference = undefined
                if(this.orderStatus == '待支付' || this.orderStatus == '待审核') {
			    	startTime = dayjs(this.orderInfo.addDate)
			    	timeEnd = startTime.add(7, 'day')
			    	now = dayjs()
			    	timeDifference = dayjs.duration(timeEnd.diff(now))
			    	this.count = Math.ceil(timeDifference.asSeconds())
			    	this.countTimer = setInterval(() => {
			    		if(this.count >= 1) {
			    			this.count -= 1
			    			this.timeout = `${timeFormat(this.count).day}天 ${timeFormat(this.count).hours}:${timeFormat(this.count).minutes}:${timeFormat(this.count).seconds}`
			    		}else {
			    			clearInterval(this.countTimer)
			    		}
			    	}, 1000)
			    }else if(this.orderStatus == '待核对') {
			    	startTime = dayjs(this.orderInfo.experimentEndDate)
			    	timeEnd = startTime.add(3, 'day')
			    	now = dayjs()
			    	timeDifference = dayjs.duration(timeEnd.diff(now))
			    	this.count = Math.ceil(timeDifference.asSeconds())
			    	this.countTimer = setInterval(() => {
			    		if(this.count >= 1) {
			    			this.count -= 1
			    			this.timeout = `${timeFormat(this.count).day}天 ${timeFormat(this.count).hours}:${timeFormat(this.count).minutes}:${timeFormat(this.count).seconds}`
			    		}else {
			    			clearInterval(this.countTimer)
			    		}
			    	}, 1000)
			    }
                const globalList = res.data.equipmentSubscribe.globalFieldValues
			    const groupsList = res.data.equipmentSubscribe.groups
			    //处理全局字段
			    const norenderList = [8,11,13]
			    globalList.forEach(item => {
			    	if(!norenderList.includes(item.fieIdType)) {
			    		if(item.fieIdType == 9) {
			    			this.globalInfo.push({label: item.fieIdName, value: `${item.fieIdValue} ~ ${item.fieldValueRange}`})
			    		} else if(item.fieIdType == 12 && item.fieldGroupValues) {
			    			item.fieldGroupValues.forEach(item_ => {
			    				if(item_.fieIdType == 9) {
			    					this.globalInfo.push({label: item_.fieIdName, value: `${item_.fieIdValue} ~ ${item_.fieldValueRange}`})
			    				} else {
			    					this.globalInfo.push({label: item_.fieIdName, value: item_.fieIdValue})
			    				}
			    			})
			    		} else {
			    			this.globalInfo.push({label: item.fieIdName, value: item.fieIdValue})
			    		}
			    	}
			    })
                //处理字段组字段
			    groupsList.forEach(groupsList_item => {
			    	const obj = {
			    		groupName: groupsList_item.sampleName + '组样品信息',
			    		groupData: []
			    	}
			    	if(groupsList_item.values) {
			    		groupsList_item.values.forEach(item => {
			    			if(!norenderList.includes(item.fieIdType)) {
			    				if(item.fieIdType == 9) {
			    					obj.groupData.push({label: item.fieIdName, value: `${item.fieIdValue} ~ ${item.fieldValueRange}`})
			    				} else if(item.fieIdType == 12 && item.fieldGroupValues) {
			    					item.fieldGroupValues.forEach(item_ => {
			    						if(item_.fieIdType == 9) {
			    							obj.groupData.push({label: item_.fieIdName, value: `${item_.fieIdValue} ~ ${item_.fieldValueRange}`})
			    						} else {
			    							obj.groupData.push({label: item_.fieIdName, value: item_.fieIdValue})
			    						}
			    					})
			    				} else {
			    					obj.groupData.push({label: item.fieIdName, value: item.fieIdValue})
			    				}
			    			}
			    		})
			    	}
			    	this.groupsInfo.push(obj)
			    })
                //处理附件列表
                this.fileList = res.data.equipmentSubscribe.fileList.map(item => {
			    	return {
			    		label: item.name,
			    		url: this.imgurl + item.url
			    	}
			    })
                this.orderInfoLoading = false
            })
        },
        //返回上页
        close() {
            this.$emit('close')
        },
        //下载附件
        downloadFile(data) {
            if(data.url.includes("statics/")){
                const fileName = data.label
                if ('download' in document.createElement('a')) {
                    //非IE下载
                    const a = document.createElement('a')
                    a.download = fileName.replace(new RegExp('"', 'g'), '')
                    a.style.display = 'none'
                    a.href = data.url
                    document.body.appendChild(a)
                    a.click()
                    URL.revokeObjectURL(a.href) //释放URL 对象
                    document.body.removeChild(a) //删掉a标签
                } else {
                    this.$message.error('不支持IE浏览器下载数据文件，请使用其他浏览器')
                }
            } else {
                let obj = {
                    key: data.url,
                    attname: data.label
                }
                getDownLoadUrl(obj).then(res => {
                    let url = res.msg
                    window.open(url)
                })
            }
        },
        //下载实验结果
        downloadResult(data) {
            this.$emit('downloadResult', data)
        },
        //导出预约单信息
       exportExperiment() {
            this.exportExperimentLoading = true
            this.$confirm('请将下载的PDF打印，与样品一起寄出！', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(async () => {
                await this.$download.getDownLoadXls('/file/communal/download/client/exportExperimentData/'+ this.orderInfo.orderId)
                this.exportExperimentLoading = false
            }).catch(() => {
                this.exportExperimentLoading = false
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: calc(100vh - 200px);
    background-color: #fff;
    .info-card {
        margin-bottom: 20px;
    }
    .tips {
        text-align: left;
        margin-bottom: 15px;
        .download-result {
            cursor: pointer;
            text-decoration: underline;
        }
        .download-result:hover {
            color: #84B7F9;
        }
    }
    .info-box {
        flex: 1;
        display: flex;
        border: 1px solid #ddd;
        .info-box-title {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 120px;
            background-color: #84B7F950;
        }
        .info-box-content {
            display: flex;
            align-items: center;
            padding: 15px;
            width: calc(100% - 120px);
            min-width: 200px;
        }
    }
}

.baseInfo-box {
    display: flex;
    column-gap: 20px;
    .equipment-pic {
        width: 250px;
        height: 250px;
        border: 1px solid #ddd;
        border-radius: 10px;
    }
    .baseInfo{
        display: flex;
        row-gap: 10px;
        column-gap: 10px;
        flex-wrap: wrap;
    }
}
.price {
    display: flex;
    column-gap: 10px;
    margin-bottom: 10px;
    .info-box-content {
        font-weight: 600;
        color: #FF4A2B;
    }
}
.original-box {
    display: flex;
    row-gap: 10px;
    column-gap: 10px;
    flex-wrap: wrap;
}
.experiment-box {
    display: flex;
    row-gap: 10px;
    column-gap: 10px;
    flex-wrap: wrap;
    padding-top: 10px;
}
.detection-box {
    border: 1px solid #ddd;
    .detection-title {
        padding: 15px;
        text-align: center;
        border-bottom: 1px solid #ddd;
        background-color: #F5F5F5;
    }
    .detection-info {
        flex: 1;
        display: flex;
        border-bottom: 1px solid #ddd;
        .detection-info-title {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 200px;
            padding: 20px;
            background-color: #84B7F950;
        }
        .detection-info-content {
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            justify-content: center;
            align-items: center;
            padding: 15px;
        }
    }
    .fieId-title {
        padding: 15px;
        border-bottom: 1px solid #ddd;
        background-color: #F5F5F5;
    }
    .message {
        padding: 15px;
        border-bottom: 1px solid #ddd;
    }
    .file-list {
        padding: 15px;
        border-bottom: 1px solid #ddd;
        .file {
            cursor: pointer; 
            text-decoration: underline; 
            color: #5CC300;
        }
    }
}


</style>